export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "contextWorker.cf6c7648.worker.js");
}
